class Api {
    
    public static URL_PREFIX = process.env.REACT_APP_URL_PREFIX;
    // public static URL_PREFIX = "http://localhost:28080";
    // public static URL_PREFIX = "https://admin.winch.intcon-sys.com/api";
    public static CODE_OK = "0";
}

export default Api;
